import { render, staticRenderFns } from "./TheCard.vue?vue&type=template&id=bb46d360&scoped=true"
var script = {}
import style0 from "./TheCard.vue?vue&type=style&index=0&id=bb46d360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb46d360",
  null
  
)

export default component.exports